var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 52,
    viewBox: "0 0 75 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7667 37.1429L48.9697 26L29.7667 14.8571V37.1429ZM72.5387 8.06C73.0197 9.80571 73.3527 12.1457 73.5747 15.1171C73.8337 18.0886 73.9447 20.6514 73.9447 22.88L74.1667 26C74.1667 34.1343 73.5747 40.1143 72.5387 43.94C71.6137 47.2829 69.4677 49.4371 66.1377 50.3657C64.3987 50.8486 61.2167 51.1829 56.3327 51.4057C51.5227 51.6657 47.1197 51.7771 43.0497 51.7771L37.1667 52C21.6637 52 12.0067 51.4057 8.19569 50.3657C4.86569 49.4371 2.71969 47.2829 1.79469 43.94C1.31369 42.1943 0.980687 39.8543 0.758687 36.8829C0.499687 33.9114 0.388687 31.3486 0.388687 29.12L0.166687 26C0.166687 17.8657 0.758687 11.8857 1.79469 8.06C2.71969 4.71714 4.86569 2.56286 8.19569 1.63429C9.93469 1.15143 13.1167 0.817142 18.0007 0.594285C22.8107 0.334285 27.2137 0.222857 31.2837 0.222857L37.1667 0C52.6697 0 62.3267 0.594286 66.1377 1.63429C69.4677 2.56286 71.6137 4.71714 72.5387 8.06Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.b9afb70cfe7300eba675d6d0db791513.svg";
export { ForwardRef as ReactComponent };